/**
 * Created by Aleksandr on 27.04.2023
 */

const ExpeditionIcon = function (pageId) {
    this.pageId = pageId;

    SideBarIcon.call(this, {
        animation: cleverapps.travelBook.getPageById(this.pageId).sideBarIcon,
        targets: "expeditionEnergy",
        canBeOffscreen: true,
        priority: SideBar.PRIORITY_EXPENDABLE
    });
    this.resetState();
};

ExpeditionIcon.prototype = Object.create(SideBarIcon.prototype);
ExpeditionIcon.prototype.constructor = ExpeditionIcon;

ExpeditionIcon.prototype.onPressed = function () {
    cleverapps.focusManager.display({
        focus: "ExpeditionIconClicked",
        action: function (f) {
            const page = cleverapps.travelBook.getPageById(this.pageId);

            if (typeof ExpeditionIntroWindow !== "undefined" && ExpeditionIntroWindow.hasIntro(page) && !page.isCompleted()) {
                new ExpeditionIntroWindow(page);
                cleverapps.focusManager.onceNoWindowsListener = f;
            } else {
                cleverapps.meta.switchLocation(this.pageId);
                cleverapps.meta.gotoLocationScene(f);
            }
        }.bind(this)
    });
};

ExpeditionIcon.getPriorityPage = function () {
    const pages = cleverapps.travelBook.listAvailablePages()
        .filter((page) => !page.isMain && page.isActive())
        .sort((a, b) => b.getStartTime() - a.getStartTime());
    const next = pages[(pages.findIndex((page) => page.isCurrent()) + 1) % pages.length];
    return next && !next.isCurrent() ? next : undefined;
};

ExpeditionIcon.prototype.resetState = function () {
    const priorityPage = ExpeditionIcon.getPriorityPage();

    this.available = priorityPage && (priorityPage.id === this.pageId);
    if (this.available) {
        const page = cleverapps.travelBook.getPageById(this.pageId);
        this.setAttention(page.attention);
        if (page.isCompleted()) {
            this.setLeftTime(0);
            this.setTitle(Messages.get("Finished"));
        } else {
            this.setLeftTime(page.getTimeLeft());
            this.setTitle(undefined);
        }
    }
};
